import { z } from 'zod';
import { ExperienceStepSchema } from './Experience.schema';
import { ExtrasSchema } from './Extra.schema';
import { GuestFieldFormSchema } from './Guest.schema';
import { SelectExperienceSchema } from './SelectExperience.schema';
import { TablesSchema } from './Tables.schema';
import { SpaExtrasSchema } from './SpaExtra.schema';

const packagesGuestSchema = z.object({
  guestDetails: GuestFieldFormSchema,
  roomNumber: z.number(),
  experiences: ExperienceStepSchema.optional(),
});

const packagesGuestsSchema = z.array(packagesGuestSchema);

export const PackagesSchema = z.object({
  guests: packagesGuestsSchema,
  roomNotes: z.string().optional(),
  spaNotes: z.string().optional(),
  extras: ExtrasSchema,
  tables: TablesSchema.optional(),
  selectedExperiences: SelectExperienceSchema.optional(),
  visitDate: z.string(),
  spaExtras: SpaExtrasSchema,
});

export type PackagesFormValues = z.infer<typeof PackagesSchema>;
export type PackagesGuest = z.infer<typeof packagesGuestSchema>;
export type PackagesGuests = z.infer<typeof packagesGuestsSchema>;
